import {
  type MarginProperties,
  marginProperties,
} from '../../styles/sprinkle-properties.js';

/**
 * Converts a spacing token to its corresponding CSS value.
 * @internal
 */
export const spacingToCss = (
  spacingToken: MarginProperties | undefined,
): number | string | undefined => {
  if (spacingToken === undefined) {
    return undefined;
  }
  return marginProperties[spacingToken];
};
